import React, { useMemo } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import * as styles from './navItem.module.scss'
import { TasksNavItemProps } from './types'

const TasksNavItem = ({ path, label, icon, totalTasks }: TasksNavItemProps) => {
   const badge = useMemo(
      () => (
         <div
            className={classNames(styles.navItemCircle, {
               [styles.hidden]: totalTasks === 0,
               [styles.smallText]: totalTasks > 999,
            })}
         >
            {totalTasks}
         </div>
      ),
      [totalTasks]
   )

   return (
      <Link className={styles.navItemLink} to={path}>
         {icon}
         {label}
         {badge}
      </Link>
   )
}

export default TasksNavItem
